module.exports = __webpack_public_path__ + "static/media/icon_attach_file.c1742090.svg";